import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowUpStyle0 = gravityIconIndividualCss;

const GravityIconArrowUp = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '222aac1a88a7c6ddcc6e5f8eb766b571a24b11af', color: this.color, size: this.size }, h("svg", { key: 'fd04ecfe6cc10ef91bcaf31382a1a3024f8abd47', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c42df8d397b851b31e76b2826913c596efab180e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.79 8.21-5.28 5.28a.3.3 0 0 0 .21.51h10.56a.3.3 0 0 0 .21-.51l-5.28-5.28a.29.29 0 0 0-.42 0Z", fill: "currentColor" }))));
    }
};
GravityIconArrowUp.style = GravityIconArrowUpStyle0;

export { GravityIconArrowUp as gravity_icon_arrow_up };

//# sourceMappingURL=gravity-icon-arrow-up.entry.js.map